import React from 'react';
import { ProgressBar, accentStyle } from './TaskBits';
import { computeProjectProgress } from '../../../services/ProjectService';

// Portal Work (v5) — the desktop (>=980px) Views + Projects rail. It renders the
// SAME `view` / `setView` state the pill switcher owns (the pills hide at this
// width, so there is one source of truth for the active view — never both). The
// "W · Work · Tasks" identity block sits at the top per the mock; project rows
// carry an area-tinted progress bar (computeProjectProgress) and a done/total
// count, and open the existing ProjectDetail on click.
function WorkSidebar({
	views,
	view,
	setView,
	openCount,
	projects,
	allTasks,
	onOpenProject,
	// The space this rail is rendering for. Defaults to Work, which is both the
	// original behaviour and what a mount outside a private space should show.
	spaceName = 'Work',
}) {
	return (
		<aside className='wt-sidebar' aria-label='Views and projects'>
			<div className='wt-sidebar__brand'>
				<span className='wt-sidebar__mark' aria-hidden='true'>
					{spaceName.charAt(0)}
				</span>
				<span className='wt-sidebar__brandtext'>{spaceName} · Tasks</span>
			</div>

			<nav className='wt-sidebar__section' aria-label='Task views'>
				<div className='wt-sidebar__group-title'>Views</div>
				{views.map((v) => {
					const active = view === v.key;
					const count = v.key === 'needs' ? openCount : null;
					return (
						<button
							key={v.key}
							type='button'
							className={`wt-sidebar__item${
								active ? ' is-active' : ''
							}`}
							aria-current={active ? 'page' : undefined}
							onClick={() => setView(v.key)}>
							<i
								className={`fa-sharp fa-solid ${v.icon} wt-sidebar__item-ic`}
							/>
							<span className='wt-sidebar__item-label'>
								{v.label}
							</span>
							{count != null && (
								<span className='wt-sidebar__badge'>
									{count}
								</span>
							)}
						</button>
					);
				})}
			</nav>

			{projects.length > 0 && (
				<div className='wt-sidebar__section'>
					<div className='wt-sidebar__group-title'>Projects</div>
					{projects.map((p) => {
						const prog = computeProjectProgress(allTasks, p.id);
						return (
							<button
								key={p.id}
								type='button'
								className='wt-sidebar__proj'
								onClick={() => onOpenProject(p)}>
								<span className='wt-sidebar__proj-top'>
									<span
										className='wt-sidebar__proj-sq'
										style={accentStyle(p.area)}
									/>
									<span className='wt-sidebar__proj-name'>
										{p.title}
									</span>
								</span>
								<span className='wt-sidebar__proj-bar'>
									<ProgressBar
										pct={prog.pct}
										accentArea={p.area}
									/>
									<span className='wt-sidebar__proj-count'>
										{prog.done}/{prog.total}
									</span>
								</span>
							</button>
						);
					})}
				</div>
			)}
		</aside>
	);
}

export default WorkSidebar;
